/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/cancelSubscription.scss';

import React, {FocusEventHandler, MouseEventHandler, useMemo} from 'react';
import {ChangeFunction, CloseButton, ErrorType, Loader, WithBackground} from '@dvrd/dvr-controls';
import {CancelType} from "../../../../util/interfaces";
import {BolmateButton, BolmateInput} from "../../../controls";

interface Props {
    onSubmit: MouseEventHandler;
    onCancel: MouseEventHandler;
    onChange: ChangeFunction<string>;
    onResetError: FocusEventHandler;
    reason: string;
    active: boolean;
    loading: boolean;
    type: CancelType;
    error: ErrorType;
}

export default function CancelSubscription(props: Props) {
    const {reason, onCancel, onSubmit, active, loading, type, onChange, error, onResetError} = props;
    const [title, btnText, action] = useMemo(() => {
        if (type === CancelType.SUBSCRIPTION) return ['Abonnement stoppen', 'Ik begrijp het, abonnement stoppen', 'abonnement wilt stoppen'];
        return ['Account verwijderen', 'Ik begrijp het, account verwijderen', 'account wilt verwijderen'];
    }, [type]);

    return (
        <WithBackground active={active} onClose={onCancel}>
            <div className='cancel-subscription default-popup btn-2'>
                <div className='header-container'>
                    <label className='header-title'>{title}</label>
                    <CloseButton onClick={onCancel}/>
                </div>
                <div className='body-container'>
                    <Loader active={loading}/>
                    <p className='message'>We vinden het jammer dat je je {action}.
                        <br/><br/>Als je op de knop hieronder klikt, stopt het abonnement direct.
                        <br/>
                        Let op,<br/>Je betaalt alleen nog voor het aantal orders dat we al hebben verwerkt tot nu.
                        <br/>
                        Je kunt dus nog <b>1 laatste incasso</b> verwachten voor de afgelopen maand.
                        <br/><br/>Graag hieronder met ons delen waarom je stopt. Het helpt ons altijd :)
                        <br/>Groet Dave en Levi.
                    </p>
                    <BolmateInput onChange={onChange} value={reason} onFocus={onResetError} error={error}
                                  inputProps={{placeholder: 'Feedback hier altijd welkom :)', rows: 5}}
                                  area/>
                </div>
                <div className='footer-container'>
                    <BolmateButton onClick={onCancel} label='Annuleren' disabled={loading}/>
                    <BolmateButton onClick={onSubmit} label={btnText} disabled={loading} secondary color={'red'}/>
                </div>
            </div>
        </WithBackground>
    )
}